export interface TrustedWidgetConfig {
  appId: string;
  backendUrl: string;
  redirectUrl: string;
  issuer?: string;
  withOutHomePage?: boolean;
  scopes?: string[];
  getTokenEndPoint?: string;
  getUserInfoEndPoint?: string;
  enterButtonText?: string;
  menuButtons?: ICustomMenuButton[];
  customStyles?: ICustomStyles;
}

export interface IComponentStyles {
  text?: string;
  background?: string;
  hover?: string;
  position?: "left" | "center";
}

export interface ICustomStyles {
  global?: {
    color?: IComponentStyles;
    borderRadius?: string;
  };
  components?: {
    accountButton?: IComponentStyles;
    primaryButton?: IComponentStyles;
    secondaryButton?: IComponentStyles;
  };
}

export interface IMenuButton {
  text: string;
  link: string;
  type?: string;
}

export interface ICustomMenuButton extends IMenuButton {
  icon?: string | React.ReactElement;
  customStyles?: IComponentStyles;
}

export interface PrivateClaims {
  public_profile_claims_oauth?: string;
  public_profile_claims_gravatar?: string;
  public_accounts_claims_oauth?: number[];
  public_accounts_claims_gravatar?: number[];
}

export interface IUserProfile extends PrivateClaims {
  id?: string;
  login?: string;
  nickname?: string;
  given_name?: string;
  family_name?: string;
  email?: string;
  birthdate?: string;
  phone_number?: string | null;
  password_updated_at?: string;
  picture?: string;
  password_change_required?: boolean;
  custom_fields?: Record<string, unknown>;
  ExternalAccount?: Record<string, unknown>;
  deleted?: string | null;
  email_public?: string | null;
  email_verified?: boolean;
  phone_number_verified?: boolean | null;
  profile_privacy?: boolean;
}

export enum EButtonTypes {
  personal = "lk_personal",
  system = "lk_system",
  org = "lk_org",
  admin = "lk_admin",
  sso = "add_sso",
  logout = "logout",
}

export enum EDefaultConfigValues {
  issuer = "https://id.kloud.one",
  getUserInfoEndPoint = "/api/oidc/me",
  getTokenEndPoint = "/api/oidc/token",
  scopes = "openid lk profile",
  enterButtonText = "Войти",
}
